import {
  FETCH_BOOKMARKS_REQUEST,
  FETCH_BOOKMARKS_SUCCESS,
  FETCH_BOOKMARKS_FAILURE,
  ADD_BOOKMARK_REQUEST,
  ADD_BOOKMARK_SUCCESS,
  ADD_BOOKMARK_FAILURE,
  REMOVE_BOOKMARK_REQUEST,
  REMOVE_BOOKMARK_SUCCESS,
  REMOVE_BOOKMARK_FAILURE,
} from "./bookmark.actionTypes";

const initialState = {
  bookmarkList: [],
  rawBookmarksData: [],
  bookmarkListLoading: false,
  bookmarkListLoaded: false,
  bookmarkListError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BOOKMARKS_REQUEST:
      return {
        ...state,
        bookmarkListLoading: true,
        bookmarkListError: null,
      };

    case FETCH_BOOKMARKS_SUCCESS:
      return {
        ...state,
        bookmarkList: action.payload.bookmarkList,
        rawBookmarksData: action.payload.rawBookmarksData,
        bookmarkListLoading: false,
        bookmarkListLoaded: true,
      };

    case FETCH_BOOKMARKS_FAILURE:
      return {
        ...state,
        bookmarkListLoading: false,
        bookmarkListError: action.payload,
      };

    case ADD_BOOKMARK_REQUEST:
      return {
        ...state,
        bookmarkListLoading: true,
      };

    case ADD_BOOKMARK_SUCCESS:
      return {
        ...state,
        rawBookmarksData: [
          ...action.payload.rawBookmarksData,
          ...state.rawBookmarksData,
        ],
        bookmarkList: [...action.payload.bookmarkList, ...state.bookmarkList],
        bookmarkListLoading: false,
      };

    case ADD_BOOKMARK_FAILURE:
      return {
        ...state,
        bookmarkListLoading: false,
        bookmarkListError: action.payload,
      };

    case REMOVE_BOOKMARK_REQUEST:
      return {
        ...state,
        bookmarkListLoading: true,
      };

    case REMOVE_BOOKMARK_SUCCESS: {
      const deletedIds = (action.payload || []).map(String);
      return {
        ...state,
        rawBookmarksData: state.rawBookmarksData.filter(
          (item) => !deletedIds.includes(String(item.provider_number))
        ),
        bookmarkList: state.bookmarkList.filter(
          (item) => !deletedIds.includes(String(item.provider_number))
        ),
        bookmarkListLoading: false,
      };
    }

    case REMOVE_BOOKMARK_FAILURE:
      return {
        ...state,
        bookmarkListLoading: false,
        bookmarkListError: action.payload,
      };

    default:
      return state;
  }
};
